<template>
<img v-if="value === id" class="checked-img" @click="change" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/radio.svg" alt="">
<img v-else @click="change" class="checked-img"  src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/unradio.svg" />
</template>
<script>
export default {
  props: {
    value: {
      ype: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      // checked: false
    }
  },
  methods: {
    change () {
      // this.checked = !this.checked
      // if (this.checked) {
      if (this.value === this.id) {
        this.$emit('input', 0)
      } else {
        this.$emit('input', this.id)
      }
      // }
    }
  },
  computed: {
    getChecked: {
      get: function () {
        return Object.is(this.value, this.id)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
img.checked-img {
  width: 24px;
  height: 24px;
}
</style>
